<template>
  <v-card class="edit-discount-code" height="90vh">
    <v-card-title>{{ $t('admin_acc_discount_code.edit_title') }}</v-card-title>
    <v-card-text>
      <v-container fluid>
        <v-form ref="form" v-if="discountCode">
          <v-text-field readonly
                        :label="$t('admin_acc_discount_code.code')"
                        :value="discountCode.code"></v-text-field>
          <v-row>
            <v-col class="pb-0">
              <DatePickerInput :label="$t('admin_acc_discount_code.start')"
                               v-model="discountCode.start"
                               :rules="requiredRules"></DatePickerInput>
            </v-col>
            <v-col class="pb-0">
              <DatePickerInput :label="$t('admin_acc_discount_code.end')"
                               v-model="discountCode.end"
                               :rules="requiredRules"></DatePickerInput>
            </v-col>
          </v-row>
          <v-text-field readonly
                        :label="$t('admin_acc_discount_code.type')"
                        :value="$t(`admin_acc_discount_code.type_${discountCode.type}`)"></v-text-field>
          <v-text-field readonly
                        v-if="discountCode.type === 'FACILITY'"
                        :label="$t('admin_acc_discount_code.item_type')"
                        :value="discountCode.item_type.name"></v-text-field>
          <v-text-field readonly
                        v-if="discountCode.type === 'GYM_PASS'"
                        :label="$t('admin_acc_discount_code.gym_pass_type')"
                        :value="discountCode.gym_pass_type.name"></v-text-field>
          <v-text-field readonly
                        v-if="discountCode.type === 'FACILITY'"
                        :label="$t('admin_acc_discount_code.minimum_amount')"
                        prefix="$"
                        type="number"
                        step="1"
                        min="0"
                        :value="discountCode.minimum_amount"></v-text-field>
          <v-text-field readonly
                        :label="discountByValue ? $t('admin_acc_discount_code.discount_value') : $t('admin_acc_discount_code.discount_percentage')"
                        :prefix="discountByValue ? '$': '%'"
                        type="number"
                        step="1"
                        min="0"
                        :value="discount">
          </v-text-field>
          <!--          <v-text-field outlined-->
          <!--                        :label="$t('admin_acc_discount_code.quota')"-->
          <!--                        :type="infiniteQuota ? 'text' : 'number'"-->
          <!--                        step="1"-->
          <!--                        min="1"-->
          <!--                        :append-icon="infiniteQuota ? 'mdi-numeric': 'mdi-infinity'"-->
          <!--                        @click:append="infiniteQuota = !infiniteQuota"-->
          <!--                        v-model="infiniteQuota ? $t('admin_acc_discount_code.infinite') : discountCode.quota">-->
          <!--          </v-text-field>-->
          <!--          <v-text-field outlined-->
          <!--                        :label="$t('admin_acc_discount_code.use_per_account')"-->
          <!--                        :type="infiniteUsePerAccount ? 'text' : 'number'"-->
          <!--                        step="1"-->
          <!--                        min="1"-->
          <!--                        :append-icon="infiniteUsePerAccount ? 'mdi-numeric': 'mdi-infinity'"-->
          <!--                        @click:append="infiniteUsePerAccount = !infiniteUsePerAccount"-->
          <!--                        v-model="infiniteUsePerAccount ? $t('admin_acc_discount_code.infinite') : discountCode.use_per_account">-->
          <!--          </v-text-field>-->
          <v-text-field readonly
                        :label="$t('admin_acc_discount_code.quota')"
                        :type="infiniteQuota ? 'text' : 'number'"
                        step="1"
                        min="1"
                        :value="infiniteQuota ? $t('admin_acc_discount_code.infinite') : discountCode.quota">
          </v-text-field>
          <v-text-field readonly
                        :label="$t('admin_acc_discount_code.use_per_account')"
                        :type="infiniteUsePerAccount ? 'text' : 'number'"
                        step="1"
                        min="1"
                        :value="infiniteUsePerAccount ? $t('admin_acc_discount_code.infinite') : discountCode.use_per_account">
          </v-text-field>

        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit')">
        {{ $t('close') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && submit()">
        {{ $t('ok') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {onMounted, ref} from "@vue/composition-api";
import AdminBookingList from "@/components/acc_booking/booking/AdminBookingList.vue";
import DatePickerInput from "@/components/DatePickerInput.vue";
import AdminInvoiceList from "@/components/acc_booking/invoice/AdminInvoiceList.vue";

export default {
  name: 'EditDiscountCodeModal',
  components: {AdminInvoiceList, DatePickerInput, AdminBookingList},
  props: {
    discountCodeId: [String, Number],
  },
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const discountCode = ref(null);
    const discount = ref(0);
    const discountByValue = ref(true);
    const infiniteQuota = ref(false);
    const infiniteUsePerAccount = ref(false);
    const getDiscountCode = function () {
      root.$callAPI('aafb/admin/discount_code/', {
        discount_code_id: props.discountCodeId,
      }, (response) => {
        discountCode.value = {
          ...response.body.discount_code,
          start: root.$parseDate(response.body.discount_code.start, 'yyyy-MM-dd'),
          end: root.$parseDate(response.body.discount_code.end, 'yyyy-MM-dd'),
        };
        discountByValue.value = !!discountCode.value.discount_value;
        discount.value = discountByValue.value ? discountCode.value.discount_value : discountCode.value.discount_percentage;
        infiniteQuota.value = discountCode.value.quota === -1;
        infiniteUsePerAccount.value = discountCode.value.use_per_account === -1;
      });
    }
    const submit = function () {
      root.$callAPI('aafb/admin/discount_code/edit/', {
        discount_code_id: props.discountCodeId,
        ...discountCode.value,
      }, function (response) {
        emit('submit', true);
      })
    }

    onMounted(() => {
      getDiscountCode();
    })

    return {
      requiredRules,
      discountCode,
      discount,
      discountByValue,
      infiniteQuota,
      infiniteUsePerAccount,
      submit,
    }
  }
}
</script>

<style lang="less">
.edit-discount-code {
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .v-window__container {
    height: 100%;

    .v-window-item {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }

  .v-card__title, .v-card__text, .v-card__actions {
    width: 100%;
  }

  .v-card__title, .v-card__actions {
    flex: 0 0 auto;
  }

  .v-card__text {
    flex: 1 1 0;
    overflow: auto;
  }
}


</style>
